export default __webpack_public_path__ + "static/media/common-office-marker.db6a3d85.svg";